export default {
      id: "filter_xg-usage",
      viewBox: "0 0 26 26",
      url: "/" + "images/icons.3.109.2.svg#filter_xg-usage",
      toString: function () {
        return this.url;
      }
    }